import {ElMessage} from "element-plus";

const SILENCED_MESSAGE_KEYWORDS = [
    '用户id不能为空',
    'userid不能为空',
];

const normalizeMessageText = (message) => {
    return String(message ?? '').replace(/\s+/g, '').toLowerCase();
};

export const shouldSilenceElMessage = (messageOrOptions) => {
    const message = typeof messageOrOptions === 'string'
        ? messageOrOptions
        : messageOrOptions?.message;
    const normalizedMessage = normalizeMessageText(message);

    return SILENCED_MESSAGE_KEYWORDS.some((keyword) => normalizedMessage.includes(keyword));
};

export const showElMessage = (messageOrOptions, ...rest) => {
    if (shouldSilenceElMessage(messageOrOptions)) {
        return;
    }

    return ElMessage(messageOrOptions, ...rest);
};

let hasPatchedTypedMessageMethods = false;

export const patchElMessageMethods = () => {
    if (hasPatchedTypedMessageMethods) {
        return;
    }

    ['success', 'warning', 'info', 'error'].forEach((type) => {
        const originalMethod = ElMessage[type];
        if (typeof originalMethod !== 'function') {
            return;
        }

        ElMessage[type] = (messageOrOptions, ...rest) => {
            if (shouldSilenceElMessage(messageOrOptions)) {
                return;
            }

            return originalMethod.call(ElMessage, messageOrOptions, ...rest);
        };
    });

    hasPatchedTypedMessageMethods = true;
};
